import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-cards-row',
  templateUrl: './cards-row.component.html',
  styleUrls: ['./cards-row.component.scss'],
})
export class CardsRowComponent implements OnInit {
  isStart = true;
  isEnd = false;
  indexStart: any = 0;
  indexEnd: any = 2;

  isMobile = false;

  @Input() data: any;
  @ViewChild('row', { static: true }) row: any;

  constructor() {}

  ngOnInit() {
    // when the user scrolls horizontally, change an index based on the scroll position
    // and the index of the first visible card on the left

    // trigger the scroll event
    setTimeout(() => {
      this.calculateIndex();
    }, 500);

    this.row.nativeElement.addEventListener('scroll', () => {
      this.calculateIndex();
    });

    this.getIsMobile();
    // listen to the resize event to know if the user is on mobile or not
    window.addEventListener('resize', () => {
      this.getIsMobile();
      this.calculateIndex();
    });
  }

  getIsMobile() {
    if (window.innerWidth < 1024) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  calculateIndex() {
    const scrollLeft = this.row.nativeElement.scrollLeft;
    const cardWidth = this.row.nativeElement.children[0].clientWidth;
    this.indexStart = Math.floor(scrollLeft / cardWidth) + 1;
    this.indexEnd = Math.floor(
      (scrollLeft + this.row.nativeElement.clientWidth) / cardWidth
    );
    
    if (this.row.nativeElement.scrollLeft === 0) {
      this.isStart = true;
    } else {
      this.isStart = false;
    }

    if (this.indexEnd === this.data.cards.length) {
      this.isEnd = true;
    } else {
      this.isEnd = false;
    }
  }

  scrollLeft() {
    this.indexStart -= 1;
    this.indexEnd -= 1;
    const cardWidth = this.row.nativeElement.children[0].clientWidth;
    this.row.nativeElement.scrollLeft = (this.indexStart - 1) * (cardWidth + 8);

    this.calculateIndex();
  }

  scrollRight() {
    this.indexStart += 1;
    this.indexEnd += 1;

    // scroll to the right so that the nth card based on the indexEnd is fully visible
    const cardWidth = this.row.nativeElement.children[0].clientWidth;
    const containerWidth = this.row.nativeElement.clientWidth;
    const scroll = this.indexEnd * (cardWidth + 8) - containerWidth + 36;
    this.row.nativeElement.scrollLeft = scroll;
    this.calculateIndex();
  }
}
